import useScreenWidth from '@use/useScreenWidth';
import { reactive, watch } from 'vue';

const screenWidth = useScreenWidth();

interface IDeviceInfo {
  screen: string;
}

export default function useDeviceInfo() {
  const deviceInfo: IDeviceInfo = reactive({
    screen: '',
  });

  const setScreenWidth = () => {
    if (screenWidth.value >= 992) {
      deviceInfo.screen = 'desktop';
    } else if (screenWidth.value >= 768) {
      deviceInfo.screen = 'tablet';
    } else {
      deviceInfo.screen = 'mobile';
    }
  };

  setScreenWidth();

  watch(screenWidth, () => {
    setScreenWidth();
  });

  return deviceInfo;
}
